/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import Button from 'material-ui/Button';
import Snackbar from 'material-ui/Snackbar';
import Divider from 'material-ui/Divider';
import Typography from 'material-ui/Typography';
import ModeEditIcon from 'material-ui-icons/ModeEdit';
import $ from 'jquery';
import Dialog, {DialogContent,DialogContentText,withMobileDialog,} from 'material-ui/Dialog';
import { CircularProgress } from 'material-ui/Progress';
import LINK from '../constants/LinkConstants.js';

class Verification extends React.Component {

  constructor(props) {
     super(props);
     if(props.fields){
       this.state = props.fields;
     }
     this.validateNow = this.validateNow.bind(this);
     this.stepEditing = this.stepEditing.bind(this);
  }

  stepEditing(no){
    this.props.onEdit(no);
  }

  validateNow = ()  => {

    this.setState({open:true,loading:true,message:"Don't press back button or don't refresh this window. Please wait while we process your information"});
    $.ajax({
     url: LINK.createAccount,
     cache: false,
     type : 'POST',
     data : JSON.stringify(this.state),
     headers: {
       'Accept': 'application/json',
       'Content-Type': 'application/json'
     },
     success: function(response) {
       if(response.status=="error"){
         this.setState({open:true,loading:false,message:response.msg});
       } else {
         this.setState({open:false,loading:false});
         this.props.onSubmit(this.state);
       }
     }.bind(this),
     error: function(xhr, status, err) {
       this.setState({open:true,loading:false,message:"Server is not responding properly. Please try after sometime!"});
     }.bind(this)
   });
  }

  render() {

    return (
      <div >
        <Divider light />
        <Typography type="title" className="headline">Verify Information</Typography>
        <br/>
        <table cellPadding="4" cellSpacing="4" width="100%">
          <tbody>
            <tr>
              <td width="40%" className="blockLabel"><h3>Account Information</h3></td>
              <td width="60%">
                {this.props.hideButton==="true"?(
                  <div></div>
                ):(
                  <Button fab color="primary" style={{width:"35px",height:"35px"}} aria-label="edit" onClick={this.stepEditing.bind(this,0)}><ModeEditIcon /></Button>
                )}
              </td>
            </tr>
            <tr>
              <td className="boxLabel">Account Type</td>
              <td className="boxValue">
                {this.state.isAgencyLogin ? "Regular" : "Agency Account"}
              </td>
            </tr>
            <tr>
              <td className="boxLabel">Account Login</td>
              <td className="boxValue">
                {this.state.isAgencyLogin ? this.state.user_name : this.state.agencyUserName}
              </td>
            </tr>
            <tr>
              <td className="boxLabel">Unique IP Address</td>
              <td className="boxValue">&nbsp;</td>
            </tr>
            <tr>
              <td className="boxLabel">Primary Contact First Name</td>
              <td className="boxValue">{this.state.firstName}</td>
            </tr>
            <tr>
              <td className="boxLabel">Primary Contact Last Name</td>
              <td className="boxValue">{this.state.lastName}</td>
            </tr>
            <tr>
              <td className="boxLabel">Company Name</td>
              <td className="boxValue">{this.state.clientName}</td>
            </tr>
            <tr>
              <td className="boxLabel">Email Address</td>
              <td className="boxValue">{this.state.primaryContactEmail}</td>
            </tr>
            <tr>
              <td className="boxLabel">Phone Number</td>
              <td className="boxValue">{this.state.primaryContactPhone}</td>
            </tr>
            <tr>
              <td className="boxLabel">Fax</td>
              <td className="boxValue">{this.state.primaryContactFax}</td>
            </tr>
            <tr>
              <td className="boxLabel">Street Address 1</td>
              <td className="boxValue">{this.state.address_1}</td>
            </tr>
            <tr>
              <td className="boxLabel">Street Address 2</td>
              <td className="boxValue">{this.state.address_2}</td>
            </tr>
            <tr>
              <td className="boxLabel">City</td>
              <td className="boxValue">{this.state.city}</td>
            </tr>
            <tr>
              <td className="boxLabel">State/Province</td>
              <td className="boxValue">{this.state.stateName}</td>
            </tr>
            <tr>
              <td className="boxLabel">Postal Code</td>
              <td className="boxValue">{this.state.zip}</td>
            </tr>
            <tr>
              <td className="boxLabel">Country</td>
              <td className="boxValue">{this.state.country}</td>
            </tr>
            <tr><td colSpan="2"><Divider /></td></tr>
            <tr>
              <td className="blockLabel"><h3>CAN SPAM Information</h3></td>
              <td>
              {this.props.hideButton==="true"?(
                <div></div>
              ):(
                <Button fab color="primary" style={{width:"35px",height:"35px"}} aria-label="edit" onClick={this.stepEditing.bind(this,0)}><ModeEditIcon /></Button>
              )}
              </td>
            </tr>
            {this.state.canSameAccount ? (
              <tr>
                <td className="boxValue" colSpan="2">This is the same as my account info.</td>
              </tr>
            ) : (
              <tr>
              <td colSpan="2">
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="40%" className="boxLabel">Company Name</td>
                    <td width="60%" className="boxValue">{this.state.canCompanyName}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">Street Address 1</td>
                    <td className="boxValue">{this.state.canAddress1}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">Street Address 2</td>
                    <td className="boxValue">{this.state.canAddress2}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">City</td>
                    <td className="boxValue">{this.state.canCity}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">State/Province</td>
                    <td className="boxValue">{this.state.canState}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">Postal Code</td>
                    <td className="boxValue">{this.state.canZip}</td>
                  </tr>
                  <tr>
                    <td className="boxLabel">Country</td>
                    <td className="boxValue">{this.state.canCountry}</td>
                  </tr>
                </tbody>
              </table>
              </td>
              </tr>
            )}
            <tr><td colSpan="2"><Divider /></td></tr>
            <tr>
              <td className="blockLabel"><h3>Domain Information</h3></td>
              <td>
                {this.props.hideButton==="true"?(
                  <div></div>
                ):(
                  <Button fab color="primary" style={{width:"35px",height:"35px"}} aria-label="edit" onClick={this.stepEditing.bind(this,1)}><ModeEditIcon /></Button>
                )}
              </td>
            </tr>
            <tr>
              <td className="boxLabel">What domain would you like to use for this eLoop account?</td>
              <td className="boxValue">{this.state.domainName}</td>
            </tr>
            <tr>
              <td className="boxLabel">Will Gold Lasso be purchasing this domain on your behalf?</td>
              <td className="boxValue">{this.state.goldlassoWillPurchase}</td>
            </tr>
            <tr>
              <td className="boxLabel">Do you currently own the domain that you listed above?</td>
              <td className="boxValue">{this.state.currentlyOwnDomain}</td>
            </tr>
            <tr>
              <td className="boxLabel">Who will configure the DNS for this domain?</td>
              <td className="boxValue">{this.state.whoWillConfigure}</td>
            </tr>
            {this.state.addnNotes!=""?(
              <tr>
                <td className="boxLabel">Additional notes</td>
                <td className="boxValue">{this.state.addnNotes}</td>
              </tr>
            ):(
              <tr><td colSpan="2"></td></tr>
            )}
            <tr><td colSpan="2"><Divider /></td></tr>
            <tr>
              <td className="blockLabel"><h3>Billing Information</h3></td>
              <td>
                {this.props.hideButton==="true"?(
                  <div></div>
                ):(
                  <Button fab color="primary" style={{width:"35px",height:"35px"}} aria-label="edit" onClick={this.stepEditing.bind(this,2)}><ModeEditIcon /></Button>
                )}
              </td>
            </tr>
            <tr><td className="boxValue" colSpan="2">
              I will sign and send a sales order.</td>
            </tr>
          </tbody>
        </table>

        <Dialog open={this.state.open} aria-labelledby="responsive-dialog-title" >
          <DialogContent>
            {this.state.loading?(
              <div className="center">
                <CircularProgress />
              </div>
            ):(
              <div className="center" />
            )}
            <DialogContentText>
              {this.state.message}
            </DialogContentText>
          </DialogContent>

        </Dialog>
      </div>
    );
  }
}

export default Verification;



// WEBPACK FOOTER //
// ./src/components/verify.js